import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import {EventsDetailsPage} from '../events-details/events-details';
/**
 * Generated class for the EventsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})
export class EventsPage {

  title: string = 'Events';
  events: any;
  image_url: string = 'https://app.fw-wesling.de/uploads/events';

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {

      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }

      this.teamappProvider.http_request('action=get_events', 'events', false, true).then(data => {
          this.events = data;
          console.log(this.events);
      });
  }

  openEvent(e: any) {
    this.navCtrl.push(EventsDetailsPage, {details: e})  ;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/events/events.ts